import React from 'react';
import { useLocation } from 'react-router';
import { Container, Header, Table, Button, Segment, Icon } from 'semantic-ui-react';

const AppointmentConfirmation = () => {
    const location = useLocation();
    const data = location.state?.data;

    const handlePrint = () => {
        window.print();
    };

    if (!data) {
        return <Container text>No appointment data found.</Container>;
    }

    console.log(data);

    return (
        <div class={"text ui"} style={{width:'100%', 'max-width':'100% !important',padding:'1rem'}}>
            <Segment>
                <Header as="h2">
                    You have scheduled your photography appointment.
                </Header>
                <div style={{ marginBottom: '1em' }}>
                    Please
                    <Button
                        icon
                        labelPosition='left'
                        onClick={handlePrint}
                        style={{ margin: '0 0.5em' }}
                    >
                        <Icon name='print' />
                        Print
                    </Button>
                    the following for your records:
                </div>

                <Table definition>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell width={4}>Date:</Table.Cell>
                            <Table.Cell>{data.appointmentDate}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Time:</Table.Cell>
                            <Table.Cell>{data.eventTime}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Number in Family:</Table.Cell>
                            <Table.Cell>{data.numberInFamily}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Name:</Table.Cell>
                            <Table.Cell>{`${data.firstNames} ${data.lastName}`}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Street Address 1:</Table.Cell>
                            <Table.Cell>{data.address1}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>City:</Table.Cell>
                            <Table.Cell>{data.city}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>State:</Table.Cell>
                            <Table.Cell>{data.state}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Zip Code:</Table.Cell>
                            <Table.Cell>{data.zip}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Telephone:</Table.Cell>
                            <Table.Cell>{data.phoneNumber}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>Email:</Table.Cell>
                            <Table.Cell>{data.emailAddress}</Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>

                <Segment>
                    <Header as="h3">GETTING READY</Header>

                    <Header as="h4">Clothing</Header>
                    <p>
                        Solid colors work best and are more slenderizing. Avoid busy patterns and choose a color theme
                        that unifies the look of your family
                    </p>

                    <Header as="h4">Hair</Header>
                    <p>
                        Avoid changing your hairstyle or cutting your hair right before your session. Your photographer
                        will help you identify improperly placed hair, but make sure you like the look and let the photographer
                        know your preference
                    </p>

                    <Header as="h4">Jewelry</Header>
                    <p>
                        If you have jewelry that has special meaning to you, wear it! Mention to your photographer
                        that you would like them to show it in your portrait
                    </p>

                    <Header as="h4">Make-up</Header>
                    <p>
                        Apply make-up as you would normally for an evening out. Pay special attention to our eyes:
                        the focal point in a portrait
                    </p>

                    <Header as="h4">Glasses</Header>
                    <p>
                        If you wear glasses all the time, you'll want to have them in your portraits. That's the real you!
                    </p>

                    <Header as="h4">Complexion</Header>
                    <p>
                        Universal offers portrait retouching that can soften facial lines and correct blemishes.
                    </p>
                </Segment>
            </Segment>
        </div>
    );
};

export default AppointmentConfirmation;